import featureFlags from 'services/featureFlags';

export interface AdminCard {
  id: string;
  title: string;
  description: string;
  fn: string;
  requiredRole: string;
}

const adminCards: AdminCard[] = [
  {
    id: 'team-cohorts',
    title: 'Team cohorts',
    description: 'Add or remove cohorts',
    fn: 'team-cohorts',
    requiredRole: ':cohort_admin',
  },
  ...(featureFlags.notifyRoutingPlansEnabled
    ? [
      {
        id: 'team-message-plans',
        title: 'Team message plans',
        description: 'Review or add message plans to a team',
        fn: 'team-message-plans',
        requiredRole: ':routing_plan_admin',
      },
    ]
    : []),
  ...(featureFlags.manageUserDetails
    ? [
      {
        id: 'manage-user-details',
        title: 'Users',
        description: 'Update permissions and names',
        fn: 'manage-user-details/select-user',
        requiredRole: ':team_admin',
      },
    ]
    : []),
  ...(featureFlags.campaignTemplates
    ? [
      {
        id: 'campaign-templates',
        title: 'Campaign templates',
        description: 'View and manage campaign templates',
        fn: 'campaign-templates',
        requiredRole: ':campaign_template_admin',
      },
    ]
    : []),
];

export default adminCards;
